import DelayTime from './DelayTime'

export default DelayTime
